export default {
  superAdmin: [
    {
      name: 'analytics',
      icon: 'chart.svg',
      route: '/super-admin'
    },
    {
      name: 'schools',
      icon: 'schools.svg',
      route: '/super-admin/schools'
    },
    {
      users: [
        {
          name: 'users',
          icon: 'teachers.svg',
          route: '#'
        },
        {
          name: 'principal',
          icon: 'teachers.svg',
          route: '/super-admin/director'
        },
        {
          name: 'admin',
          icon: 'teachers.svg',
          route: '/super-admin/school-admin'
        },
        {
          name: 'rayono',
          icon: 'teachers.svg',
          route: '/super-admin/rayon-head'
        },
        {
          name: 'teachers',
          icon: 'teachers.svg',
          route: '/super-admin/instructors'
        },
        {
          name: 'students',
          icon: 'students.svg',
          route: '/super-admin/students'
        }
      ]
    },
    {
      name: 'courses',
      icon: 'courses.svg',
      route: '/super-admin/courses'
    },
    // {
    //   name: 'districts',
    //   icon: 'country.svg',
    //   route: '/super-admin/rayon'
    // },
    // {
    //   name: 'chronicleYear',
    //   icon: 'library.svg',
    //   route: '/super-admin/chronicle'
    // },
    {
      name: 'markTypes',
      icon: 'journal.svg',
      route: '/super-admin/grade-reason'
    },
    {
      name: 'videoInstructions',
      icon: 'videocam.svg',
      route: '/super-admin/video-material'
    },
    {
      name: 'declarations',
      icon: 'announcement.svg',
      route: '/super-admin/announcements'
    },
    {
      name: 'chat',
      icon: 'message.svg',
      route: '/super-admin/chat'
    },
    {
      name: 'peopleSearch',
      icon: 'students.svg',
      route: '/super-admin/search-user'
    }
    // {
    //   name: 'library',
    //   icon: 'library.svg',
    //   route: '/super-admin/library'
    // }
  ],

  minEducation: [
    {
      name: 'analytics',
      icon: 'chart.svg',
      route: '/min-education'
    },
    {
      name: 'schools',
      icon: 'schools.svg',
      route: '/min-education/schools'
    },
    {
      users: [
        {
          name: 'users',
          icon: 'teachers.svg',
          route: '#'
        },
        {
          name: 'principal',
          icon: 'teachers.svg',
          route: '/min-education/director'
        },
        {
          name: 'admin',
          icon: 'teachers.svg',
          route: '/min-education/school-admin'
        },
        {
          name: 'rayono',
          icon: 'teachers.svg',
          route: '/min-education/rayon-head'
        },
        {
          name: 'teachers',
          icon: 'teachers.svg',
          route: '/min-education/instructors'
        },
        {
          name: 'students',
          icon: 'students.svg',
          route: '/min-education/students'
        }
      ]
    },
    {
      name: 'courses',
      icon: 'courses.svg',
      route: '/min-education/courses'
    },
    {
      name: 'districts',
      icon: 'country.svg',
      route: '/min-education/rayon'
    },
    {
      name: 'chronicleYear',
      icon: 'library.svg',
      route: '/min-education/chronicle'
    },
    {
      name: 'markTypes',
      icon: 'journal.svg',
      route: '/min-education/grade-reason'
    },
    {
      name: 'videoInstructions',
      icon: 'videocam.svg',
      route: '/min-education/video-material'
    }
  ],

  schoolAdmin: [
    {
      name: 'analytics',
      icon: 'chart.svg',
      route: '/school-admin'
    },
    {
      name: 'aboutSchool',
      icon: 'schools.svg',
      route: '/school-admin/about-school'
    },
    {
      name: 'teachers',
      icon: 'teachers.svg',
      route: '/school-admin/teachers'
    },
    {
      name: 'courses',
      icon: 'courses.svg',
      route: '/school-admin/courses'
    },
    {
      name: 'classes',
      icon: 'courses.svg',
      route: '/school-admin/classes'
    },
    {
      name: 'students',
      icon: 'students.svg',
      route: '/school-admin/students'
    },
    {
      name: 'schedule',
      icon: 'schedule.svg',
      route: '/school-admin/schedule-week'
    },
    {
      name: 'quarter',
      icon: 'schedule.svg',
      route: '/school-admin/school-quarter'
    },
    {
      name: 'reports',
      icon: 'report.svg',
      route: '/school-admin/admin-report'
    },
    {
      name: 'videoInstructions',
      icon: 'videocam.svg',
      route: '/school-admin/video-material'
    },
    {
      name: 'declarations',
      icon: 'announcement.svg',
      route: '/school-admin/announcements'
    },
    {
      name: 'chat',
      icon: 'message.svg',
      route: '/school-admin/chat'
    },
    {
      name: 'archive',
      icon: 'students.svg',
      route: '/school-admin/archive-users'
    },
    // {
    //   name: 'library',
    //   icon: 'library.svg',
    //   route: '/school-admin/library'
    // },
    {
      name: 'library',
      icon: 'library.svg',
      route: '/school-admin/study-material'
    },
    {
      name: 'replaceTeacher',
      icon: 'teachers.svg',
      route: '/school-admin/replace-teacher'
    }
  ],

  director: [
    {
      name: 'analytics',
      icon: 'chart.svg',
      route: '/director'
    },
    {
      name: 'aboutSchool',
      icon: 'schools.svg',
      route: '/director/about-school'
    },
    {
      name: 'teachers',
      icon: 'teachers.svg',
      route: '/director/teachers'
    },
    {
      name: 'courses',
      icon: 'courses.svg',
      route: '/director/courses'
    },
    {
      name: 'classes',
      icon: 'courses.svg',
      route: '/director/classes'
    },
    {
      name: 'students',
      icon: 'students.svg',
      route: '/director/students'
    },
    {
      name: 'schedule',
      icon: 'schedule.svg',
      route: '/director/schedule-week'
    },
    {
      name: 'chat',
      icon: 'message.svg',
      route: '/director/chat'
    },
    {
      name: 'reports',
      icon: 'report.svg',
      route: '/director/director-report'
    }
  ],

  instructor: [
    {
      name: 'notification',
      icon: 'ring-bell.svg',
      route: '/instructor/notification'
    },
    {
      name: 'analytics',
      icon: 'chart.svg',
      route: '/instructor'
    },
    {
      name: 'log',
      icon: 'journal.svg',
      route: '/instructor/journal-grade'
    },
    {
      name: 'quarter_grade',
      icon: 'quarter-grade.svg',
      route: '/instructor/quarter-grade'
    },
    {
      name: 'myClasses',
      icon: 'my-class.svg',
      route: '/instructor/classes'
    },
    {
      name: 'topics',
      icon: 'book-open.svg',
      route: '/instructor/topics'
    },
    {
      name: 'schedule',
      icon: 'schedule.svg',
      route: '/instructor/schedule'
    },
    {
      name: 'onlineLesson',
      icon: 'videocam.svg',
      route: '/instructor/online-lesson'
    },
    {
      name: 'reports',
      icon: 'report.svg',
      route: '/instructor/instructor-report'
    },
    {
      name: 'declarations',
      icon: 'announcement.svg',
      route: '/instructor/announcement'
    },
    {
      name: 'videoInstructions',
      icon: 'videocam.svg',
      route: '/instructor/video-material'
    },
    {
      name: 'chat',
      icon: 'message.svg',
      route: '/instructor/chat'
    },
    {
      name: 'library',
      icon: 'library.svg',
      route: '/instructor/study-material'
    },
    {
      name: 'minEducationForms',
      icon: 'book-open.svg',
      route: '/instructor/forms'
    }
  ],

  rayonHead: [
    {
      name: 'analytics',
      icon: 'chart.svg',
      route: '/rayon-head'
    },
    {
      name: 'schools',
      icon: 'schools.svg',
      route: '/rayon-head/schools'
    },
    {
      name: 'teachers',
      icon: 'teachers.svg',
      route: '/rayon-head/instructors'
    },
    {
      name: 'students',
      icon: 'students.svg',
      route: '/rayon-head/students'
    },
    {
      name: 'reports',
      icon: 'report.svg',
      route: '/rayon-head/rayon-head-report'
    }
    // {
    //     name: 'Календарь',
    //     icon: 'calendar.svg',
    //     route: '/rayon-head/calendar'
    // }
  ],

  parent: [
    {
      name: 'notification',
      icon: 'ring-bell.svg',
      route: '/parent'
    },
    {
      name: 'schedule',
      icon: 'schedule.svg',
      route: '/parent/schedule'
    },
    {
      name: 'quarter_grade',
      icon: 'quarter-grade.svg',
      route: '/parent/quarterGrade'
    },
      {
          name: 'chat',
          icon: 'message.svg',
          route: '/parent/chat'
      },
    {
      name: 'library',
      icon: 'library.svg',
      route: '/parent/study-material'
    },
    {
      name: 'kyrgyz_alphabet',
      icon: 'library.svg',
      route: '/parent/kyrgyzAlphabet'
    },
    {
      name: 'days_and_months',
      icon: 'library.svg',
      route: '/parent/DaysMonths'
    },
    {
      name: 'mult_table',
      icon: 'library.svg',
      route: '/parent/MultTable'
    },
    {
      name: 'hymn',
      icon: 'library.svg',
      route: '/parent/Hymn'
    },
    {
      name: 'manas',
      icon: 'library.svg',
      route: '/parent/Manas'
    }
  ],

  student: [
    {
      name: 'notification',
      icon: 'ring-bell.svg',
      route: '/student'
    },
    {
      name: 'schedule',
      icon: 'schedule.svg',
      route: '/student/schedule'
    },
    {
      name: 'quarter_grade',
      icon: 'quarter-grade.svg',
      route: '/student/quarterGrade'
    },
    {
      name: 'plane',
      icon: 'quarter-grade.svg',
      route: '/student/plane'
    },
    {
      name: 'onlineLesson',
      icon: 'videocam.svg',
      route: '/student/online-lesson'
    },
      {
          name: 'chat',
          icon: 'message.svg',
          route: '/student/chat'
      },
    {
      name: 'library',
      icon: 'library.svg',
      route: '/student/study-material'
    },
    {
      name: 'kyrgyz_alphabet',
      icon: 'library.svg',
      route: '/student/kyrgyzAlphabet'
    },
    {
      name: 'days_and_months',
      icon: 'library.svg',
      route: '/student/DaysMonths'
    },
    {
      name: 'mult_table',
      icon: 'library.svg',
      route: '/student/MultTable'
    },
    {
      name: 'hymn',
      icon: 'library.svg',
      route: '/student/Hymn'
    },
    {
      name: 'manas',
      icon: 'library.svg',
      route: '/student/Manas'
    }
  ]
}
